var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('navigation-tabs', _vm._l(_vm.menuList, function (v, i) {
    return _c('router-link', {
      key: i,
      attrs: {
        "to": {
          name: v.pathName,
          params: {
            id: _vm.$route.params.id
          }
        }
      }
    }, [_vm._v(" " + _vm._s(_vm.$t(v.name)) + " ")]);
  }), 1), _c('v-dialog', {
    attrs: {
      "width": "450"
    },
    model: {
      value: _vm.unsavedChangesDialog,
      callback: function ($$v) {
        _vm.unsavedChangesDialog = $$v;
      },
      expression: "unsavedChangesDialog"
    }
  }, [_c('v-card', [_c('v-card-title', [_vm._v(" " + _vm._s(_vm.$t('unsaved_changes_dialog_title')) + " ")]), _c('v-card-text', {
    staticClass: "pt-3"
  }, [_c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.$t('unsaved_changes_dialog_description'))
    }
  })]), _c('v-card-actions', [_c('v-spacer'), _c('v-btn', {
    attrs: {
      "text": "",
      "color": "primary",
      "small": "",
      "dense": ""
    },
    on: {
      "click": function ($event) {
        _vm.unsavedChangesDialog = false;
      }
    }
  }, [_vm._v(" " + _vm._s(_vm.$t('cancel')) + " ")]), _c('v-btn', {
    attrs: {
      "text": "",
      "color": "red",
      "small": "",
      "dense": ""
    },
    on: {
      "click": function ($event) {
        return _vm.continueNavigation();
      }
    }
  }, [_vm._v(" " + _vm._s(_vm.$t('continue_without_saving')) + " ")])], 1)], 1)], 1)], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }